import { RemoveCircleOutline } from "@mui/icons-material";
import React from "react";
import { getImagePath, sortItemsByHeightAndLength } from "../../../SharedFiles/Helper/utils";

const ItemData = ({ itemData, cartItems, openModal, removeFromCart }) => {

    return (
        <ul className="lineborder itempageLine">
            {itemData?.length > 0 ? (
                sortItemsByHeightAndLength(itemData).map((data, index) => {
                    // Check if the item is already in the cart
                    const existingItemIndex = cartItems.findIndex(cartItem => cartItem.item_Code === data.item_Code);

                    return (
                        <div key={index} className="lineDiv lineDivItem">

                            {/* {existingItemIndex === -1 ? (
                                    <span className="image-div">
                                        <img
                                            src={getImagePath(data.deliverY_TYPE)}
                                            alt={data.deliverY_TYPE  || "Product image"}
                                            className="group-image"
                                        />
                                    </span>) : (
                                    <div className="removeiconitemPage" onClick={() => removeFromCart(data.item_Code)}>
                                        <RemoveCircleOutline />
                                    </div>)} */}
                            {existingItemIndex === -1 ? (
                                <span className="image-div">
                                    {getImagePath(data.deliverY_TYPE) ? (
                                        <img
                                            src={getImagePath(data.deliverY_TYPE)}
                                            alt={data.deliverY_TYPE || "Product image"}
                                            className="group-image"
                                        />
                                    ) : (
                                        <div className="image-placeholder">img</div> 
    )}
                                </span>
                            ) : (
                                <div
                                    className="removeiconitemPage"
                                    onClick={() => removeFromCart(data.item_Code)}
                                >
                                    <RemoveCircleOutline />
                                </div>
                            )}

                            <li className="groupSizeItemPage align-items-center">
                                <div className="itmlist">
                                    <p className="itemcode item">{data.item_Name}</p>
                                    <span className="itemname item">{data.height.toFixed(1)} mm</span>
                                    <p className="itemcode item">{data.item_Code}</p>
                                    <p className="itemStock item">(onStock:{data.itemStock.toLocaleString()} nos)</p>
                                </div>

                                {/* Show "Add" button if item is not in the cart, else show quantity */}
                                {existingItemIndex === -1 ? (
                                    <button className="AddCart" onClick={() => openModal(data)}>
                                        <p className="item">Add <i className="pi pi-plus"></i> </p>
                                    </button>
                                ) : (
                                    <div className="quantityDisplay AddCart" onClick={() => openModal(data)}>
                                        {/* <p className="item">{cartItems[existingItemIndex].quantity}</p> */}
                                        <p className="item">
                                            {cartItems[existingItemIndex].type === "bundle"
                                                ? cartItems[existingItemIndex].quantity
                                                : cartItems[existingItemIndex].quantityNos}
                                        </p>
                                    </div>
                                )}
                            </li>
                        </div>
                    );
                })
            ) : (
                <p className="no-orders-message" >No data found</p>
            )}
        </ul>
    );
};

export default ItemData;